"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jwt_decode_1 = __importDefault(require("jwt-decode"));
/**
 * A convenience method to test if a passed prop has been defined.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is defined.
 */
exports.isDefined = function (prop) {
    return typeof prop !== "undefined" && prop !== "undefined";
};
/**
 * A convenience method to test if a passed property is a blank string.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is in fact a blank string.
 */
exports.isBlank = function (prop) { return !exports.isNotBlank(prop); };
/**
 * A convenience method to test if a passed property is a non blank string.
 * @param {*} prop A property to test.
 * @return {boolean} True if the passed prop is in fact a non blank string.
 */
exports.isNotBlank = function (prop) {
    return exports.isDefined(prop) && typeof prop === "string" && prop !== "";
};
/**
 *
 * @param {string} token A JWT to validate.
 * @param {number} leeway A pessimistic amount of seconds to invalidate the token. (defaults to 10)
 */
exports.validateToken = function (token, leeway) {
    if (exports.isBlank(token)) {
        return false;
    }
    var currentToken = jwt_decode_1.default(token);
    var exp = currentToken.exp;
    var now = new Date().getTime() / 1000;
    var secondsRemaining = exp - now;
    return secondsRemaining > (leeway || 10);
};
